<template>
  <div>
    <div v-if="version" class="version-string" @click="openPatchNotesModal">
      v{{ version }}
    </div>
    <patch-notes-editor ref="modalRef" modal-id="patch-notes-navbar" />
  </div>
</template>

<script lang="ts" setup>
  import { onMounted, ref } from 'vue';
  import PatchNotesEditor from '@/components/PatchNotesEditor/PatchNotesEditor.vue';
  import { PatchNotesService } from '@/services';

  const version = ref<string | null>(null);

  async function getCurrentVersion(): Promise<void> {
    version.value = await PatchNotesService.getCurrentAppVersion();
  }

  const modalRef = ref<InstanceType<typeof PatchNotesEditor> | null>(null);
  async function openPatchNotesModal(): Promise<void> {
    modalRef.value?.show();
  }

  onMounted(getCurrentVersion);
</script>

<style lang="scss" scoped>
  .version-string {
    cursor: pointer;
  }
</style>
